import React from 'react';
import logo from './no-glasses.svg';
import './App.css';
import { 
  LinkOutlined, 
  LinkedinOutlined, 
  MailOutlined, 
  FileOutlined
} from '@ant-design/icons'

function App() {
  return (
    <div className="App">
    <div className="Content">
      <div className="Logo">
        <div className="GlassesOverlay">
          <div className="Glasses">
            <div className="LeftCircle"/>
            <div className="RightCircle"/>
          </div>
        </div>
        <img className="" src={logo} alt="Logo" />
      </div>
      <div className="Space"/>
      <div className="Body">
        <div className="Title">
          Charleen Wang
        </div>
        <div className="Item">
          <div className="Item-Title">Software Engineer @ Samsara <a href="https://medium.com/samsara-engineering/dev-spotlight-charleen-wang-174fef85a3fd">
              <LinkOutlined className="SubItem"/>
            </a></div>
          <div className="Item-Details">
            <div className="SubItem">SRE</div>
            <div className="SubItem Date">Aug 2020 - Jul 2023</div>
          </div>
          <div className="Item-Details">
            <div className="SubItem">Fullstack</div>
            <div className="SubItem Date">Mar - Aug 2019</div>
          </div>
        </div>
        <div className="Item">
          <div className="Item-Title"> MIT</div>
          <div className="Item-Details">
          <div className="SubItem">B.S. Computer Science</div>
            <div className="SubItem Date">2020</div>
          </div>
        </div>
        <div className="Item">
        <div className="Item-Details">
          <a className="SubItem" href="https://www.linkedin.com/in/charleenw/">
            <LinkedinOutlined />
          </a>
          <a className="SubItem" href="mailto: charleen23wang@gmail.com">
            <MailOutlined />
          </a>
        </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default App;
